<div id="side-filters" class=" side-nav-filters fixed top-0 shadow bg-white z-40 flex flex-col"
  [ngClass]="isShowFilters ? 'right-0' : 'hide-nav-filters'">

  <header class="flex items-center justify-between border-bottom px-4 py-4">
    <div class="flex items-center">
      <button matRipple color="primary" (click)="toggleNav()" aria-label="Drawer Close Button"
        class="flex items-center justify-center rounded-full h-9 w-9">
        <i class="ico-ArrowRight text-2xl"></i>
      </button>
      <h3>فیلترها</h3>
    </div>

    <div class="flex w-full items-center justify-end lg:hidden">
      <button *ngIf="showRemoveBtn" (click)="removeAllFilters()" class="!border
      !border-solid
      !border-blue-500 ml-5" mat-button color="primary">
        حذف فیلترها
      </button>
     
    </div>


  </header>

    <mat-accordion [multi]="false" class="filters-sidebar-accordion !text-black w-full mt-2 px-5 flex flex-col">
      <ng-container *ngFor="let item of dataSource; let first = first; let last = last; let i = index">
        <mat-expansion-panel *ngIf="item.Items.length" [expanded]="expanded()" class="border-bottom"
          [class.border-bottom-0.!pb-0]="i === dataSource.length - 1">
          <mat-expansion-panel-header class="!px-0">
            <mat-panel-title>
              <div class="w-full flex justify-between items-center">
                <div>
                  <p class="text-base font-bold">{{ item.Title }}</p>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
        <div [ngSwitch]="item.Key">
          <div *ngSwitchCase="'labelsAccomodate'">
            <iho-labels-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
          </div>
            <div *ngSwitchCase="'labels'">
              <iho-labels-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
              <div *ngSwitchCase="'reviews'">
                <iho-comments-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
              </div>
              <div *ngSwitchCase="'facilities'">
                <iho-accommodation-facilities-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
              </div>
              <div *ngSwitchCase="'rules'">
                <iho-rules-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
              </div>
  
            <div *ngSwitchCase="'grades'">
              <iho-stars-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
        
         
          <div *ngSwitchCase="'types'">
            <iho-residence-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
          </div>
            <div *ngSwitchCase="'hotelTypes'">
                <iho-residence-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </div>
            <div *ngSwitchCase="'price'">
              <ng-container *ngIf="showPriceFilter() && csrStatus()">
                <iho-price-filter [_reset]="reset()" (checkedMinValue)="MinValue($event)" (checkedMaxValue)="MaxValue($event)"
                  [dataSource]="item.Items" />
              </ng-container>
            </div>
            <div *ngSwitchCase="'hotelStyles'">
              <iho-type-of-location-filter (checkedItemsEmit)="checkedItemsEmit($event)" 
              [dataSource]="item.Items" />
            </div>
         
       
       
        </div>
      </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  <div  class="w-full mx-auto fixed bg-white bottom-0 p-3 shadow-2xl z-40">
    <button class="w-full !h-11" (click)="setFilters()" mat-raised-button color="primary">
      اعمال فیلتر
    </button>
  </div>
</div>